import { AbstractChart } from './abstract_chart';

class ScatterChart extends AbstractChart {

	constructor(element) {
		super(element, 'scatter');
	}

	addDataset(name, values, opt_options) {
		const options = Object.assign( {
			pointRadius: 3
		}, opt_options || {});
	
    	return super.addDataset(name, values, options);
	} 
}

const scatter = (element) => {
	return new ScatterChart(element);
};


export {
	scatter
}
